import React from 'react'
import './home.css'
import { Link } from 'react-router-dom'
import profilePicture from './profilePicture.jpg'


const Home = () => {
  return (
    <div className='home'>
    <div className="headings">
      <div className="first-para">
        Hi, I am
      </div>
      <h1 className="heading">
        Saddam Anwar
      </h1>
      <p className="sec-para">
      As a skilled full-stack (MERN) developer with over two years of experience, I specialize in building dynamic and responsive web applications. My expertise spans React.js for creating user-friendly interfaces, Redux for state management, and Tailwind CSS for modern, scalable designs. On the backend, I utilize Node.js and Express.js to develop robust APIs, while Mongoose ensures efficient data handling with MongoDB. I am passionate about delivering high-performance solutions that enhance user experiences and achieve project goals effectively.
<br /> <br />
If you want to work with me, click the "Hire Me" button below and send me an email or contact me via the social media options provided.
      </p>
      <Link to="/contact" className="home-btn">Hire Me</Link>
      <div className="icons">
      <a href="https://wa.me/+923339794414" target="_blank" rel="noreferrer" className='whatsapp'><i class="fa-brands fa-whatsapp"></i></a>
        <a href="https://youtube.com/@ms__brand09?si=zJHNe3zTOm4EuI6e" className="youtube"><i className='fa-brands fa-youtube'></i></a>
        <a href="https://www.instagram.com/saddam__programmer/profilecard/?igsh=MXBiejJjZjV1c2oyMw==" className="instagram"><i className='fa-brands fa-instagram'></i></a>
        <a href="https://www.tiktok.com/@saddam__khan7?_t=8psycGA09yx&_r=1"  className="tiktok"><i className='fa-brands fa-tiktok'></i></a>
      </div>
    </div>
    <img className='profile-pic' src={profilePicture} alt="my pic" />

      
    </div>
  )
}

export default Home
